import { render, staticRenderFns } from "./label2Modal.vue?vue&type=template&id=11a084d6&scoped=true"
import script from "./label2Modal.vue?vue&type=script&lang=js"
export * from "./label2Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a084d6",
  null
  
)

export default component.exports